import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AmountPaymentPlanPageRoutingModule } from './amount-payment-plan-routing.module';

import { AmountPaymentPlanPage } from './amount-payment-plan.page';
import { MasterHeaderModule } from '../master-header/master-header.module';
import { MasterFooterModule } from '../master-footer/master-footer.module';
import { CustomInputModule } from '../common-components/custom-input/custom-input.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MasterHeaderModule,
    MasterFooterModule,
    ReactiveFormsModule,
    CustomInputModule,
    AmountPaymentPlanPageRoutingModule
  ],
  declarations: [AmountPaymentPlanPage]
})
export class AmountPaymentPlanPageModule {}
